import request from '@/router/axios'

//创建试卷
export function createExam (obj) {
  return request({
    url: '/exam/admin/exam',
    method: 'post',
    data: obj,
  })
}

//试卷详情
export function getExamDetail (id) {
  return request({
    url: `/exam/admin/exam/${id}`,
    method: 'get',
  })
}

//试卷列表
export function getExamList (param) {
  return request({
    url: '/exam/admin/exams',
    method: 'get',
    params: param,
  })
}

//删除试卷
export function deleteExam (id) {
  return request({
    url: `/exam/admin/exam/${id}`,
    method: 'delete',
  })
}

//编辑试卷
export function editExam (obj) {
  return request({
    url: `/exam/admin/exam/${obj.id}`,
    method: 'put',
    data: obj,
  })
}

//编辑试卷状态
export function publishExam (id) {
  return request({
    url: `/exam/admin/exam/${id}/publish`,
    method: 'put'
  })
}

export function abortExam (id) {
  return request({
    url: `/exam/admin/exam/${id}/abort`,
    method: 'put'
  })
}



//试卷结果
export function getRecord (param) {
  return request({
    url: `/exam/admin/record/${param.examId}`,
    method: 'get',
    params: param,
  })
}

export function getMemberList (param) {
  return request({
    url: '/exam/admin/members/',
    method: 'get',
    params: param,
  })
}
